import React from 'react'
import { NavLink } from 'react-router-dom'

import * as Navigate from '../../navigate'

import './left-nav.css'

const LeftNav = ({ current_reg_holder }) => (
  <ul>
    <li>
      <NavLink to={Navigate.toGovRegistrationsByCareType(current_reg_holder || {})}>
        Gov Registrations
      </NavLink>
    </li>

    {/* <li>
      <NavLink to={Navigate.toReports()}>Reports</NavLink>
    </li> */}

    {/* 
    <li>
      <NavLink to={Navigate.toProviderRegistrations()}>CCS Registrations</NavLink>
    </li>
   */}

    {current_reg_holder &&
      current_reg_holder.name && (
      <li className="currentServiceNav">
        <ul>
          <li>
            <NavLink to={Navigate.toEnrolmentsByCareType(current_reg_holder)}>Enrolments</NavLink>
          </li>
          <li>
            <NavLink to={Navigate.toSubmissionsByCareType(current_reg_holder)}>
                Submissions
            </NavLink>
          </li>
          <li>
            <NavLink to={Navigate.toPaymentsByCareType(current_reg_holder)}>Payments</NavLink>
          </li>
          <li>
            <NavLink to={Navigate.toPersonnel(current_reg_holder)}>Personnel</NavLink>
          </li>
          <li>
            <NavLink to={Navigate.toIssCases(current_reg_holder)}>ISS Cases</NavLink>
          </li>
          <li>
            <NavLink to={Navigate.toISSCaseClaims(current_reg_holder)}>ISS Case Claims</NavLink>
          </li>
          <li>
            <NavLink to={Navigate.toReports(current_reg_holder)}>Reports</NavLink>
          </li>
        </ul>
      </li>
    )}
  </ul>
)

export default LeftNav



// WEBPACK FOOTER //
// ./src/layout/left-nav/index.jsx